module.exports = __webpack_public_path__ + "static/media/p-coverage.910eee46.svg";